import { Card, Statistic } from "antd"
import React from "react"

const SCard = ({ label, value, suffix, prefix }: { label: string, value: string|number, suffix?: React.ReactNode, prefix?: React.ReactNode }) => {
  return <Card style={{ borderRadius: "8px",    background: 'aliceblue' }}>
    <Statistic className="his-static" title={label} value={value} suffix={suffix} prefix={prefix} />
  </Card>
}

export default SCard